module.exports = __webpack_public_path__ + "static/media/icon-moons-loading.49ab3ded.png";